import { FetchListOptions, PaginationMeta } from '~/api/_types';
import {
    fetchNotificationsRequest,
    fetchNotificationStatusRequest,
    patchNotificationActionRequest,
} from '~/api/notifications';
import { NotificationDetail, NotificationList, NotificationStatus } from '~/api/notifications/_types';
import { NotificationAction } from '~/enums/_types';
import { useNotificationsStore } from '~/stores/notifications';

export const fetchNotificationStatus = async (): Promise<{
    isSuccess: boolean;
    data: NotificationStatus | null;
}> => {
    const { isSuccess, data } = await fetchNotificationStatusRequest();

    if (isSuccess && data != null) {
        updateStatus(data);
    }

    return { isSuccess, data };
};

/**
 * @param opt
 */
export const fetchNotifications = async (
    opt?: FetchListOptions
): Promise<{ isSuccess: boolean; data: NotificationList | null; meta: PaginationMeta | null }> => {
    const res = await fetchNotificationsRequest(opt);

    if (res.isSuccess && res.data != null) {
        updateStatus(res.data.Status);
    }

    return res;
};

/**
 * @param id
 */
export const setNotificationRead = async (
    id: string
): Promise<{ isSuccess: boolean; data: NotificationDetail | null }> => {
    const res = await patchNotificationActionRequest({ id, action: NotificationAction.Read });

    if (res.isSuccess && res.data != null) {
        updateStatus(res.data.Status);
    }

    return res;
};

/**
 * @param id
 */
export const setNotificationUnread = async (
    id: string
): Promise<{ isSuccess: boolean; data: NotificationDetail | null }> => {
    const res = await patchNotificationActionRequest({ id: id, action: NotificationAction.Unread });

    if (res.isSuccess && res.data != null) {
        updateStatus(res.data.Status);
    }

    return res;
};

const updateStatus = (status: NotificationStatus): void => {
    const store = useNotificationsStore();
    store.status = status;
};
